import Cookies from 'js-cookie';
import { AppDispatch } from 'redux';
import { DMM_AUTH_COOKIE, SHARED_STATE_REPLACE } from './constants';
import { ICookieInteractions, ICookieContext } from './index';
import { removeItem, setItem } from '../../models/localStorage/actions';
import { DMM_SESSION_DATA } from '../../models/localStorage/constants';
import { getItem } from '../../models/localStorage/selectors';
import { AppState } from '../../store';
import { checkForCookieMismatch, clearCookie } from './cookie';

export const hasDMMCookie = () =>
  !!Cookies.get(DMM_AUTH_COOKIE);

export const recordDMMCookie = () => async (dispatch: AppDispatch) => {
  if (Cookies.get(DMM_AUTH_COOKIE)) {
    dispatch(setItem(DMM_SESSION_DATA, Cookies.get(DMM_AUTH_COOKIE)));
  }
};

export const checkAuthCookieDMM = () => async (dispatch: AppDispatch, getState: () => AppState) => {
  const previousVal = getItem(getState(), DMM_SESSION_DATA) || '';
  // The latest cookie has been set by DMM upon login
  const newVal = Cookies.get(DMM_AUTH_COOKIE) || '';
  try {
    return dispatch(checkForCookieMismatch(previousVal, newVal));
  } catch (err) {
    dispatch(removeItem(DMM_SESSION_DATA));
    throw err;
  }
};

export const makeDmmCookieInteractions = (context: ICookieContext): ICookieInteractions => ({
  cleanCookieData: () => (dispatch) => {
    dispatch(removeItem(DMM_SESSION_DATA));
  },
  setAuthCookie: recordDMMCookie,
  checkAuthCookie: () => (dispatch) => dispatch(checkAuthCookieDMM()),
  clearSharedCookie: () => clearCookie({ context, key: SHARED_STATE_REPLACE }),
});
